import { SessionProvider as NextAuthSessionProviderBase } from '@/shared/services/session/compat'

export const NextAuthSessionProvider = ({
  session,
  staleTime,
  clientMaxAge,
  refetchInterval,
  refetchOnWindowFocus,
  children
}) => {
  return (
    <NextAuthSessionProviderBase
      basePath="/api/auth"
      session={session}
      staleTime={staleTime}
      clientMaxAge={clientMaxAge}
      refetchInterval={refetchInterval}
      refetchOnWindowFocus={refetchOnWindowFocus}
    >
      {children}
    </NextAuthSessionProviderBase>
  )
}

